'use strict';

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _setPrototypeOf = require('babel-runtime/core-js/object/set-prototype-of');

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

var _defineProperty2 = require('babel-runtime/core-js/object/define-property');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = _assign2.default || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; (0, _defineProperty3.default)(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactSelectize = require('react-selectize');

var _helpers = require('../../helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { (0, _defineProperty3.default)(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass; }

var EntoroMultiSelect = function (_React$Component) {
  _inherits(EntoroMultiSelect, _React$Component);

  function EntoroMultiSelect() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, EntoroMultiSelect);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EntoroMultiSelect.__proto__ || (0, _getPrototypeOf2.default)(EntoroMultiSelect)).call.apply(_ref, [this].concat(args))), _this), _this.removeByValue = function (value) {
      var _this$props = _this.props,
          values = _this$props.values,
          onChange = _this$props.onChange;


      var nextValues = values.filter(function (v) {
        return v !== value;
      });

      onChange(nextValues);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EntoroMultiSelect, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          onChange = _props.onChange,
          options = _props.options,
          _renderValue = _props.renderValue,
          getUniqueLabel = _props.getUniqueLabel,
          groups = _props.groups,
          values = _props.values,
          renderTitle = _props.renderTitle,
          reverseDropDown = _props.reverseDropDown,
          otherProps = _objectWithoutProperties(_props, ['onChange', 'options', 'renderValue', 'getUniqueLabel', 'groups', 'values', 'renderTitle', 'reverseDropDown']);

      // Create map of selected values to optimize comparison of options to values


      var selectedValuesMap = (values || []).reduce(function (acc, value) {
        return _extends({}, acc, _defineProperty({}, value, true));
      }, {});

      var selectedOptions = options.filter(function (_ref2) {
        var value = _ref2.value;
        return selectedValuesMap[value];
      });

      return _react2.default.createElement(
        'div',
        null,
        renderTitle(),
        _react2.default.createElement(_reactSelectize.MultiSelect, _extends({
          values: selectedOptions,
          groups: groups,
          options: options,
          filterOptions: _helpers.filterMultiSelectOptions,
          onValuesChange: function onValuesChange() {
            var changedOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

            onChange(changedOptions.map(function (_ref3) {
              var value = _ref3.value;
              return value;
            }));
          },
          renderValue: function renderValue(option) {
            var label = getUniqueLabel(option);

            var onRemoveByValue = function onRemoveByValue(event) {
              event.preventDefault();
              _this2.removeByValue(option.value);
            };

            return _renderValue(_extends({}, option, {
              label: label
            }), onRemoveByValue);
          },
          dropdownDirection: reverseDropDown ? -1 : 1
        }, otherProps))
      );
    }
  }]);

  return EntoroMultiSelect;
}(_react2.default.Component);

EntoroMultiSelect.propTypes = {
  onChange: _propTypes2.default.func.isRequired,
  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string.isRequired,
    value: _propTypes2.default.string.isRequired
  })).isRequired,
  renderValue: _propTypes2.default.func.isRequired,
  getUniqueLabel: _propTypes2.default.func,
  groups: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    groupId: _propTypes2.default.string.isRequired
  })),
  values: _propTypes2.default.arrayOf(_propTypes2.default.string),
  renderTitle: _propTypes2.default.func,
  reverseDropDown: _propTypes2.default.bool,
  theme: _propTypes2.default.oneOf(['default', 'material', 'bootstrap3'])
};

EntoroMultiSelect.defaultProps = {
  getUniqueLabel: _helpers.getUniqueLabel,
  groups: [],
  values: [],
  renderTitle: function renderTitle() {
    return null;
  },
  reverseDropDown: false,
  theme: 'default'
};

exports.default = EntoroMultiSelect;